var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Spinner", { attrs: { id: "spinner", "is-loading": _vm.isLoading } }),
      !_vm.isLoading
        ? _c("div", [
            _c(
              "div",
              { attrs: { id: "rp-products" } },
              [
                _c("b-button", { attrs: { "icon-left": "home", active: "" } }, [
                  _vm._v(" Hipotecario "),
                ]),
                _c(
                  "b-button",
                  { attrs: { disabled: "", "icon-left": "plus" } },
                  [_vm._v(" Complementario ")]
                ),
                _c(
                  "b-button",
                  {
                    attrs: { disabled: "", "icon-left": "hand-holding-dollar" },
                  },
                  [_vm._v(" Pie hipotecario ")]
                ),
                _c(
                  "b-button",
                  { attrs: { disabled: "", "icon-left": "building" } },
                  [_vm._v(" PYME ")]
                ),
                _c(
                  "b-button",
                  { attrs: { disabled: "", "icon-left": "cart-shopping" } },
                  [_vm._v(" Consumo ")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "card-item" }, [
              _c(
                "div",
                {
                  staticClass: "columns is-mobile my-0",
                  attrs: { id: "rp-header" },
                },
                [
                  _c(
                    "b-field",
                    { staticClass: "column", attrs: { expanded: "" } },
                    [
                      _c("b-taginput", {
                        attrs: {
                          id: "search-tags",
                          data: _vm.filteredTags,
                          autocomplete: "",
                          field: "tags",
                          icon: "label",
                          placeholder: _vm.$t("policyFilter"),
                        },
                        on: {
                          input: _vm.updateHeaderPolicies,
                          typing: _vm.getFilteredTags,
                        },
                        model: {
                          value: _vm.selectedTags,
                          callback: function ($$v) {
                            _vm.selectedTags = $$v
                          },
                          expression: "selectedTags",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "column is-narrow" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass:
                            "is-primary is-light is-small is-rounded",
                          attrs: {
                            id: "show-new-risk-policy",
                            "icon-left": "fa-solid fa-plus",
                          },
                          on: { click: _vm.showNewPolicy },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "is-size-7 has-text-weight-normal" },
                            [_vm._v(" " + _vm._s(_vm.$t("create")) + " ")]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { attrs: { id: "risk-policies-list" } },
                [
                  _c("Spinner", {
                    attrs: { "is-loading": _vm.isHeaderPoliciesLoading },
                  }),
                  !_vm.isHeaderPoliciesLoading
                    ? _c(
                        "div",
                        _vm._l(_vm.headerPolicies, function (policy, index) {
                          return _c(
                            "div",
                            {
                              key: index,
                              ref: `policy-item-${index}`,
                              refInFor: true,
                              staticClass: "policy-item card-item shadowless",
                              class: _vm.headerPolicies[index]?.successApply,
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "policy-actions" },
                                [
                                  _c("b-switch", {
                                    staticClass: "policy-status",
                                    attrs: {
                                      size: "is-small",
                                      "data-cy": "policy-status",
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.togglePolicyStatus(policy)
                                      },
                                    },
                                    model: {
                                      value: _vm.headerPolicies[index].isActive,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.headerPolicies[index],
                                          "isActive",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "headerPolicies[index].isActive",
                                    },
                                  }),
                                  _c("b-button", {
                                    staticClass: "policy-details",
                                    attrs: {
                                      "icon-left": "gear",
                                      "aria-expanded": _vm.openStates[index],
                                      "aria-controls": `collapse-${index}`,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.togglePolicyDetails(
                                          index,
                                          policy._id
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.openStates[index],
                                      expression: "!openStates[index]",
                                    },
                                  ],
                                  staticClass: "policy-details",
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "title is-size-6 has-text-primary mb-0",
                                    },
                                    [_vm._v(_vm._s(policy.policyName))]
                                  ),
                                  _c(
                                    "small",
                                    {
                                      staticClass:
                                        "summary has-text-weight-normal",
                                    },
                                    [_vm._v(_vm._s(policy.description))]
                                  ),
                                ]
                              ),
                              _c("Spinner", {
                                attrs: {
                                  "is-loading":
                                    _vm.isPolicyLoading &&
                                    index === _vm.currPolicyIndex,
                                },
                              }),
                              _c(
                                "b-collapse",
                                {
                                  attrs: {
                                    animation: "slide",
                                    "aria-id": `collapse-${index}`,
                                  },
                                  model: {
                                    value: _vm.openStates[index],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.openStates, index, $$v)
                                    },
                                    expression: "openStates[index]",
                                  },
                                },
                                [
                                  policy && _vm.openStates[index]
                                    ? _c("RiskPolicyDetail", {
                                        attrs: {
                                          policy: policy,
                                          tags: _vm.filteredTags,
                                          index: index,
                                        },
                                        on: {
                                          "change:policy": _vm.handledApply,
                                          cancel: _vm.hidePolicyDetail,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }